var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatAndDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "200px",
    viewBox: "0 0 229 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    d: "M228.326,186.159c-0,9.005 -51.115,16.308 -114.163,16.308c-63.048,0 -114.163,-7.3 -114.163,-16.308c-0,-9.008 51.113,-16.31 114.163,-16.31c63.05,0 114.163,7.302 114.163,16.31Z",
    style: {
      fill: "#d0dcf7",
      fillOpacity: 0.35,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    d: "M201.591,114.674c-0.151,-0.491 -0.608,-0.829 -1.121,-0.829c-0.514,-0 -0.971,0.338 -1.122,0.829c-6.272,19.4 -17.719,41.486 -40.749,42.567c-1.493,0.07 -1.5,2.4 0,2.326c0.077,0 0.15,-0.013 0.228,-0.018c20.335,24.628 51.093,-24.863 42.764,-44.875Z",
    style: {
      fill: "#996d6d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    d: "M161.125,78.94c-0.374,-0.817 -1.058,-1.451 -1.9,-1.763c-8.224,-7.1 -21.344,-13.783 -30.67,-4.373c-4.9,4.936 -7.112,11 -9,17.572c-2.859,9.984 -6.3,19.793 -9.258,29.748c-4.239,14.268 -15.275,35.078 -9.5,49.817c3.765,9.6 20.254,12.918 29.344,14.762c18.517,3.758 55.362,2.843 62.455,-19.569c9.729,-30.706 -19.321,-60.604 -31.471,-86.194Z",
    style: {
      fill: "#ffa98f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    d: "M184.884,119.777c-0.943,-2.313 -2.156,-4.507 -3.613,-6.536c-6.945,-12.021 -15.04,-23.542 -20.147,-34.3c-0.374,-0.817 -1.058,-1.451 -1.9,-1.763c-5.558,-4.8 -13.351,-9.4 -20.7,-8.978c6.758,0.386 13.691,4.6 18.762,8.978c0.842,0.312 1.526,0.946 1.9,1.763c4.44,9.355 8.94,15.371 15.179,25.706c0.4,3.158 1.914,10.269 2.718,13.4c0.433,1.69 2.331,2.8 3.538,3.86c2.921,2.569 3.216,5.286 2.926,9.014c-0.171,2.193 -0.421,4.061 1.08,5.782c1.116,1.128 1.58,2.752 1.23,4.3c-0.646,1.519 -0.889,3.18 -0.706,4.821c1.039,8.617 -0.131,17.359 -3.4,25.4c-0.583,1.428 -1.231,2.83 -1.721,4.293c-0.278,1.314 -0.796,2.565 -1.529,3.69c-1.017,0.903 -2.211,1.584 -3.506,2c-2.832,1.245 -5.769,2.236 -8.776,2.961c-6.163,1.461 -12.475,2.205 -18.809,2.217c18.363,0.153 39.946,-4.646 45.2,-21.251c4.893,-15.474 -0.057,-30.742 -7.726,-45.357Z",
    style: {
      fill: "#ef9884",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    d: "M176.657,154.331c-1.414,-16.437 -4.852,-53.078 -6.837,-53.119c-9.793,-7.848 -12.8,8.72 -13.48,15.416c-1.892,18.723 -5.552,39.062 -3.343,57.731c1.032,8.752 14.1,28.992 21.881,13.316c4.956,-9.986 2.702,-22.63 1.779,-33.344Z",
    style: {
      fill: "#996d6d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    d: "M165.668,175.935c-6.43,-0.148 -16.225,0.871 -17.689,8.442c-0.655,3.388 1.786,6.188 4.448,7.821c3.767,2.319 8.656,2.83 12.977,2.928c6.223,0.146 16.121,-2.128 16.809,-9.848c0.789,-8.878 -10.132,-10.226 -16.545,-9.343Z",
    style: {
      fill: "#996d6d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    d: "M137.274,155.791c-1.414,-16.436 -4.853,-53.077 -6.838,-53.118c-9.792,-7.851 -12.8,8.719 -13.48,15.418c-1.892,18.722 -5.552,39.06 -3.341,57.731c1.031,8.749 14.1,28.987 21.879,13.31c4.955,-9.984 2.699,-22.624 1.78,-33.341Z",
    style: {
      fill: "#996d6d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    d: "M127.58,177.342c-6.431,-0.145 -16.226,0.876 -17.689,8.446c-0.658,3.387 1.785,6.185 4.446,7.823c3.768,2.318 8.657,2.827 12.978,2.93c6.224,0.14 16.121,-2.13 16.812,-9.853c0.786,-8.876 -10.134,-10.221 -16.547,-9.346Z",
    style: {
      fill: "#996d6d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    d: "M153.533,11.082c-4.436,4.807 11.932,32.491 21.5,43.867c7.449,8.859 22.847,24.915 35.406,15.816c9.594,-6.951 -4.924,-35.641 -7.852,-43.525c-7.846,-21.115 -20.989,-34.122 -40.131,-23.406c-3.317,1.96 -6.325,4.403 -8.923,7.248Z",
    style: {
      fill: "#996d6d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M136.345,11.082c4.433,4.807 -11.936,32.491 -21.5,43.867c-7.448,8.859 -22.848,24.915 -35.405,15.816c-9.594,-6.951 4.922,-35.641 7.851,-43.525c7.843,-21.116 20.983,-34.122 40.127,-23.407c3.318,1.961 6.327,4.404 8.927,7.249Z",
    style: {
      fill: "#996d6d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M184.173,52.261c-2.278,-17.364 -10.81,-50.5 -43.734,-48.278c-22.159,1.5 -31.023,32.241 -33.329,47.556c-2.306,15.315 -13.792,14.764 -7.927,31.119c5.15,14.359 18.328,13.918 29.616,12.939c2.2,1.86 7.2,3.164 13.019,3.164c4.764,0 8.971,-0.875 11.552,-2.209c13.647,1.56 28.934,2.147 34.762,-8.916c10.757,-20.42 -2.189,-21.883 -3.959,-35.375Z",
    style: {
      fill: "#ffa98f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M184.173,52.262c-1.48,-11.281 -5.6,-29.217 -17.336,-39.792c9.381,11.03 14.258,30.446 15.6,40.962c1.769,13.882 12.985,11.647 2.226,32.653c-5.829,11.379 -19.006,9.025 -32.653,7.421c-2.582,1.372 -8.533,4.482 -13.3,4.482c-2.154,0.007 -4.304,-0.19 -6.421,-0.591c3.083,0.951 6.297,1.412 9.523,1.365c4.764,-0 8.971,-0.875 11.552,-2.209c13.647,1.56 28.934,2.147 34.762,-8.916c10.763,-20.42 -2.183,-21.879 -3.953,-35.375Z",
    style: {
      fill: "#ef9884",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M162.572,59.947c-3.727,-5.379 -7.109,-10.093 -18.465,-11.563c-11.356,-1.47 -24.422,9.82 -26.895,21.8c-2.891,13.992 12.582,19.587 23.511,20.37c10.9,0.779 26.161,-2.337 28.762,-14.806c1.391,-6.65 -3.345,-10.654 -6.913,-15.801Z",
    style: {
      fill: "#996d6d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M155.496,64.295c-0.418,-0.744 -1.5,0 -1.093,0.733c1.752,3.145 1.848,7.869 -1.121,10.353c-1.925,1.606 -4.83,1.059 -6.715,-0.263c-2.528,-1.78 -3.43,-5.31 -2.993,-8.208c0.004,-0.031 0.006,-0.062 0.006,-0.093c0,-0.37 -0.305,-0.676 -0.676,-0.676c-0.034,0 -0.067,0.003 -0.101,0.008c-0.1,-0.064 -0.217,-0.097 -0.335,-0.097c-0.306,-0 -0.569,0.223 -0.619,0.524c-0.653,4.056 -2.277,7.363 -6.662,8.1c-4.97,0.835 -6.654,-7.347 -3.667,-12.344c0.432,-0.727 -0.757,-0.908 -1.291,-0.252c-3.8,4.618 -1.692,13.372 3.31,13.906c4.6,0.491 7.415,-2.358 8.792,-6.075c0.829,4.857 4.93,9.164 10.291,7.336c5.121,-1.751 5.036,-9.088 2.874,-12.952Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M149.178,61.479c-0.13,1.748 -4.869,5.381 -6.451,5.12c-2.4,-0.393 -5.742,-4.286 -5.607,-6.034c0.135,-1.748 2.941,-2.964 6.267,-2.709c3.326,0.255 5.926,1.875 5.791,3.623Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    d: "M158.242,44.078c-1.826,0.319 -3.171,1.92 -3.171,3.774c-0,0.531 0.11,1.056 0.324,1.542c0.439,0.949 2,0.424 1.552,-0.538c-0.161,-0.311 -0.245,-0.655 -0.245,-1.005c0,-1.035 0.736,-1.936 1.751,-2.142c1.928,-0.632 2.819,1.18 2.888,2.809c0.038,0.42 0.395,0.746 0.817,0.746c0.45,0 0.82,-0.37 0.82,-0.82c-0,-0.011 -0.001,-0.022 -0.001,-0.033c-0.109,-2.643 -1.862,-4.99 -4.735,-4.333Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    d: "M132.766,34.744c-6.438,-0.515 -8.527,4.752 -8.565,8.926c-0.036,4.132 3.785,7.938 7.995,6.5c6.307,-2.153 7.004,-14.909 0.57,-15.426Z",
    style: {
      fill: "#996d6d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M132.013,42.088c1.554,0.523 2.608,1.99 2.608,3.63c-0,0.727 -0.208,1.44 -0.598,2.054c-0.574,0.873 -2.036,0.117 -1.452,-0.765c0.272,-0.373 0.419,-0.824 0.419,-1.286c-0,-0.914 -0.574,-1.735 -1.433,-2.049c-1.81,-0.916 -2.964,0.741 -3.276,2.336c-0.102,0.349 -0.424,0.591 -0.788,0.591c-0.45,-0 -0.821,-0.371 -0.821,-0.821c-0,-0.041 0.003,-0.082 0.009,-0.122c0.502,-2.596 2.589,-4.65 5.332,-3.568Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    d: "M129.459,190.303c-0.089,-0.143 -0.534,-0.049 -0.551,0.122c-0.297,1.969 -0.969,3.864 -1.978,5.581c-0.117,0.056 -0.175,0.165 -0.122,0.242c-0.067,0.174 0.266,0.235 0.449,0.122c4.205,0.548 2.83,-5.037 2.202,-6.067Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    d: "M136.63,189.141c-0.088,-0.144 -0.533,-0.049 -0.551,0.121c-0.298,1.969 -0.969,3.864 -1.978,5.581c-0.117,0.057 -0.175,0.166 -0.122,0.243c-0.067,0.174 0.266,0.235 0.449,0.122c4.205,0.548 2.83,-5.037 2.202,-6.067Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    d: "M121.218,189.292c-0.09,-0.146 -0.534,-0.05 -0.551,0.12c-0.297,1.97 -0.968,3.864 -1.978,5.581c-0.117,0.057 -0.174,0.165 -0.122,0.243c-0.069,0.174 0.266,0.234 0.447,0.122c3.615,2.484 2.832,-5.036 2.204,-6.066Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    d: "M168.227,188.752c-0.088,-0.144 -0.533,-0.05 -0.551,0.121c-0.297,1.969 -0.969,3.864 -1.978,5.581c-0.117,0.057 -0.175,0.165 -0.122,0.242c-0.067,0.174 0.266,0.236 0.449,0.122c4.205,0.55 2.83,-5.035 2.202,-6.066Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    d: "M175.4,187.589c-0.089,-0.144 -0.534,-0.05 -0.551,0.121c-0.298,1.969 -0.969,3.864 -1.978,5.581c-0.117,0.056 -0.175,0.165 -0.122,0.242c-0.066,0.174 0.267,0.236 0.449,0.122c4.204,0.549 2.829,-5.035 2.202,-6.066Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    d: "M159.987,187.742c-0.09,-0.146 -0.534,-0.051 -0.551,0.12c-0.296,1.97 -0.968,3.865 -1.978,5.582c-0.116,0.056 -0.174,0.164 -0.122,0.242c-0.068,0.174 0.266,0.234 0.447,0.123c3.616,2.484 2.833,-5.038 2.204,-6.067Z",
    style: {
      fill: "#4c372f",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    d: "M139.215,67.978c-0,0.16 -0.26,0.291 -0.582,0.291c-0.322,0 -0.581,-0.131 -0.581,-0.291c-0,-0.16 0.26,-0.291 0.581,-0.291c0.321,0 0.582,0.13 0.582,0.291Z",
    style: {
      fill: "#996425",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    d: "M138.633,69.528c0,0.16 -0.217,0.291 -0.485,0.291c-0.268,-0 -0.485,-0.131 -0.485,-0.291c0,-0.16 0.217,-0.291 0.485,-0.291c0.268,-0 0.485,0.131 0.485,0.291Z",
    style: {
      fill: "#996425",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    d: "M136.114,69.241c0,0.321 -0.131,0.582 -0.291,0.582c-0.16,0 -0.291,-0.26 -0.291,-0.582c0,-0.322 0.13,-0.581 0.291,-0.581c0.161,0 0.291,0.256 0.291,0.581Z",
    style: {
      fill: "#996425",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    cx: 135.629,
    cy: 66.717,
    rx: 0.291,
    ry: 0.388,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    cx: 133.884,
    cy: 67.589,
    rx: 0.678,
    ry: 0.291,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    cx: 133.497,
    cy: 70.4,
    rx: 0.485,
    ry: 0.388,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    d: "M137.468,71.369c-0,0.319 -0.262,0.581 -0.581,0.581c-0.319,-0 -0.581,-0.262 -0.581,-0.581c0,-0.318 0.262,-0.58 0.58,-0.581c0.319,-0 0.581,0.262 0.582,0.581Z",
    style: {
      fill: "#996425",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    cx: 132.431,
    cy: 68.656,
    r: 0.582,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    cx: 145.902,
    cy: 70.206,
    rx: 0.678,
    ry: 0.775,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    cx: 150.458,
    cy: 70.013,
    rx: 0.388,
    ry: 0.582,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    cx: 148.423,
    cy: 71.951,
    rx: 0.485,
    ry: 0.388,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    cx: 152.3,
    cy: 72.823,
    rx: 0.291,
    ry: 0.485,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    cx: 148.908,
    cy: 73.986,
    rx: 0.388,
    ry: 0.097,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    cx: 153.56,
    cy: 69.14,
    rx: 0.582,
    ry: 0.485,
    style: {
      fill: "#996425"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    d: "M149.101,68.171c0,0.268 -0.13,0.485 -0.29,0.485c-0.16,0 -0.291,-0.217 -0.291,-0.485c-0,-0.268 0.13,-0.485 0.291,-0.485c0.161,-0 0.29,0.217 0.29,0.485Z",
    style: {
      fill: "#996425",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    d: "M94.22,188.06c-14.62,3.927 -44.157,6.931 -54.157,-7.454c-7.973,-11.477 7.425,-20.619 15.891,-24.06c8.217,-3.345 16.352,-6.725 20.21,-15.269c1.42,-3.138 -3.428,-5.368 -4.844,-2.236c-5.453,12.066 -22.271,12.282 -31.544,20.469c-7.138,6.3 -8.714,17.493 -3.294,25.29c5.821,8.375 18.7,10.177 27.971,10.913c10.634,0.905 21.346,0.003 31.679,-2.668c3.316,-0.891 1.385,-5.868 -1.912,-4.985Z",
    style: {
      fill: "#677687",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    d: "M94.087,107.731c-10.358,-13.232 -23.769,-12.3 -33.977,0.943c-11.281,14.634 -16.627,36.3 -15.428,54.534c0.416,6.345 2.355,12.945 7.409,17.1c8.612,7.087 24.78,3.218 34.924,2.711c11.493,-0.573 15.359,-6.473 17.247,-17.566c3.227,-18.964 -8.904,-57.889 -10.175,-57.722Z",
    style: {
      fill: "#e9edf4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    d: "M54.805,180.228c-5.054,-4.158 -6.994,-10.758 -7.41,-17.1c-1.2,-18.236 4.146,-39.9 15.428,-54.534c4.748,-6.158 10.189,-9.651 15.693,-10.3c-6.413,-0.342 -12.878,3.211 -18.406,10.38c-11.281,14.634 -16.627,36.3 -15.428,54.534c0.416,6.345 2.355,12.945 7.409,17.1c4.738,3.9 11.761,4.479 18.811,4.131c-6.105,0.062 -11.97,-0.815 -16.097,-4.211Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    d: "M65.552,62.01c2.464,6.671 -20.429,18.395 -22.897,11.722c-2.468,-6.673 -0.77,-25.722 2.696,-27.242c2.658,-1.164 17.737,8.848 20.201,15.52Z",
    style: {
      fill: "#e9edf4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    d: "M65.554,62.01c-2.007,-5.423 -12.339,-13.051 -17.565,-15.093c5.022,3.587 11.455,9.992 12.642,14.464c1.312,4.945 -10.062,14.245 -17.485,14.301c0.769,2.147 0.653,0.006 0.703,0.143c2.468,6.673 24.167,-7.144 21.705,-13.815Z",
    style: {
      fill: "#677687",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    d: "M57.179,65.691c1.361,3.67 -11.368,9.416 -12.722,5.752c-1.354,-3.664 -0.287,-13.447 1.621,-14.28c1.458,-0.64 9.746,4.864 11.101,8.528Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    d: "M93.406,62.147c-4.133,5.788 15.457,21.963 19.589,16.173c4.132,-5.79 6.924,-23.463 3.98,-25.839c-2.26,-1.822 -19.434,3.876 -23.569,9.666Z",
    style: {
      fill: "#e9edf4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    d: "M99.687,60.954c2.529,-3.541 9.932,-7.044 15.82,-8.817c-4.836,-0.068 -18.477,4.935 -22.1,10.01c-4.133,5.788 15.099,22.605 19.231,16.815c0.142,-0.2 -1.562,0.721 -1.422,0.495c-7.034,-2.656 -14.559,-14.258 -11.529,-18.503Z",
    style: {
      fill: "#677687",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    d: "M101.208,67.011c-2.27,3.181 8.5,12.072 10.767,8.892c2.267,-3.18 3.807,-12.9 2.188,-14.207c-1.239,-0.999 -10.683,2.133 -12.955,5.315Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    d: "M108.707,72.011c-5.469,-8.949 -10.073,-14.666 -28.1,-18.062c-18.027,-3.396 -40.733,17.43 -45.788,36.358c-5.907,22.115 18.33,32.486 35.744,34.739c17.362,2.247 42.056,-1.337 47.362,-21.042c2.828,-10.515 -3.983,-23.431 -9.218,-31.993Z",
    style: {
      fill: "#bfc0c2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    d: "M108.707,72.011c-5.469,-8.949 -10.073,-14.666 -28.1,-18.062c-12.48,-2.351 -27.202,6.907 -36.758,19.107c-4.248,5.423 -7.475,11.427 -9.03,17.251c-5.907,22.115 18.33,32.486 35.744,34.739c17.362,2.247 42.056,-1.337 47.362,-21.042c2.828,-10.515 -3.983,-23.431 -9.218,-31.993Z",
    style: {
      fill: "#e9edf4",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    d: "M118.052,101.82c-5.307,19.7 -30,23.289 -47.363,21.042c-15.681,-2.024 -36.881,-10.644 -36.638,-28.481c-2.085,19.326 20.2,28.558 36.513,30.666c17.362,2.247 42.056,-1.337 47.362,-21.042c0.43,-1.666 0.645,-3.38 0.639,-5.1c-0.096,0.983 -0.267,1.958 -0.513,2.915Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    d: "M89.234,100.539c-2.324,-3.8 -4.436,-7.128 -12.087,-8.568c-7.651,-1.44 -16.96,5.718 -19.107,13.754c-2.507,9.383 7.779,13.788 15.171,14.741c7.368,0.954 17.851,-0.568 20.1,-8.933c1.202,-4.459 -1.857,-7.362 -4.077,-10.994Z",
    style: {
      fill: "#fefdfd",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    d: "M84.26,103.216c-0.258,-0.522 -1.02,-0.059 -0.771,0.456c1.069,2.2 0.95,5.415 -1.164,6.983c-1.368,1.014 -3.32,0.534 -4.548,-0.439c-1.559,-1.443 -2.216,-3.624 -1.713,-5.688c0.006,-0.029 0.009,-0.059 0.009,-0.089c-0,-0.252 -0.207,-0.459 -0.459,-0.459c-0.015,-0 -0.03,0.001 -0.045,0.002c-0.072,-0.053 -0.16,-0.081 -0.249,-0.081c-0.199,-0 -0.372,0.14 -0.414,0.334c-0.6,2.727 -1.832,4.911 -4.838,5.24c-3.407,0.375 -4.23,-5.246 -2.01,-8.525c0.322,-0.476 -0.476,-0.646 -0.865,-0.219c-2.761,2.985 -1.67,9.013 1.7,9.567c3.1,0.514 5.125,-1.312 6.208,-3.779c0.372,3.327 2.988,6.413 6.7,5.38c3.548,-0.992 3.771,-5.977 2.459,-8.683Z",
    style: {
      fill: "#323c47",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    d: "M78.412,102.276c-0.1,0.754 -2.241,2.207 -2.919,2.055c-1.032,-0.229 -2.378,-2 -2.276,-2.749c0.102,-0.749 1.346,-1.21 2.78,-1.016c1.434,0.194 2.514,0.957 2.415,1.71Z",
    style: {
      fill: "#323c47",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    d: "M88.922,89.157c-1.562,0.182 -2.753,1.521 -2.753,3.093c0,0.371 0.066,0.739 0.196,1.087c0.312,0.793 1.6,0.436 1.285,-0.363c-0.102,-0.228 -0.155,-0.475 -0.155,-0.726c-0,-0.879 0.654,-1.632 1.524,-1.755c1.592,-0.424 2.229,1.086 2.212,2.409c0.016,0.354 0.312,0.637 0.666,0.637c0.359,-0 0.656,-0.289 0.667,-0.647c0.036,-2.149 -1.28,-4.132 -3.642,-3.735Z",
    style: {
      fill: "#323c47",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    d: "M67.733,86.325c1.176,0.473 1.95,1.62 1.95,2.887c-0,0.65 -0.204,1.284 -0.583,1.813c-0.508,0.685 -1.658,0 -1.144,-0.687c0.26,-0.317 0.401,-0.715 0.401,-1.125c0,-0.706 -0.421,-1.349 -1.069,-1.63c-1.425,-0.826 -2.439,0.467 -2.767,1.744c-0.088,0.275 -0.345,0.463 -0.634,0.463c-0.366,-0 -0.666,-0.301 -0.666,-0.666c-0,-0.052 0.006,-0.104 0.018,-0.155c0.53,-2.08 2.317,-3.652 4.494,-2.644Z",
    style: {
      fill: "#323c47",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    d: "M75.595,164.36c-1.12,-9.573 -3.781,-30.906 -4.941,-30.9c-5.857,-4.411 -7.32,5.318 -7.6,9.242c-0.768,10.966 -2.543,22.909 -0.921,33.77c0.759,5.09 8.753,16.678 13.014,7.385c2.718,-5.915 1.177,-13.257 0.448,-19.497Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    d: "M70.461,177.106c-4.4,-0.053 -11.044,0.6 -11.791,5.043c-0.335,1.986 1.423,3.614 3.294,4.558c2.649,1.336 6,1.608 8.955,1.645c4.25,0.05 10.924,-1.335 11.14,-5.862c0.242,-5.206 -7.254,-5.937 -11.598,-5.384Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    d: "M98.108,163.673c-1.12,-9.573 -3.778,-30.906 -4.939,-30.9c-5.857,-4.412 -7.322,5.317 -7.6,9.242c-0.77,10.965 -2.545,22.908 -0.922,33.77c0.758,5.089 8.753,16.678 13.016,7.385c2.715,-5.915 1.173,-13.257 0.445,-19.497Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    d: "M94.01,176.665c-3.757,0.026 -9.462,0.8 -10.182,5.246c-0.322,1.988 1.156,3.58 2.738,4.488c2.241,1.284 5.106,1.495 7.63,1.478c3.636,-0.028 9.375,-1.532 9.64,-6.052c0.303,-5.198 -6.1,-5.791 -9.826,-5.16Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    d: "M99.696,181.306c-0.1,-0.112 -0.525,0.042 -0.528,0.191c-0.126,1.792 -0.613,3.54 -1.433,5.139c-0.108,0.068 -0.155,0.17 -0.1,0.229c-0.05,0.161 0.281,0.16 0.448,0.034c4.156,-0.201 2.318,-4.807 1.613,-5.593Z",
    style: {
      fill: "#677687",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    d: "M91.564,181.746c-0.1,-0.111 -0.525,0.042 -0.527,0.191c-0.126,1.792 -0.614,3.54 -1.433,5.139c-0.108,0.068 -0.156,0.17 -0.1,0.229c-0.051,0.161 0.281,0.16 0.448,0.034c3.752,1.57 2.317,-4.804 1.612,-5.593Z",
    style: {
      fill: "#677687",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    d: "M76.166,182.756c-0.088,-0.12 -0.527,-0.013 -0.545,0.136c-0.311,1.769 -0.977,3.458 -1.958,4.963c-0.115,0.056 -0.173,0.154 -0.12,0.217c-0.067,0.155 0.263,0.189 0.442,0.08c4.15,0.234 2.801,-4.537 2.181,-5.396Z",
    style: {
      fill: "#677687",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    d: "M68.032,182.353c-0.088,-0.122 -0.526,-0.013 -0.544,0.136c-0.311,1.769 -0.977,3.457 -1.958,4.962c-0.115,0.056 -0.173,0.154 -0.12,0.218c-0.068,0.154 0.262,0.188 0.442,0.08c3.561,1.95 2.8,-4.538 2.18,-5.396Z",
    style: {
      fill: "#677687",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    d: "M60.155,130.098c0.226,-0.063 0.3,-0.764 0.095,-0.871c-2.427,-1.412 -4.544,-3.3 -6.222,-5.552c-0.02,-0.2 -0.131,-0.335 -0.255,-0.293c-0.19,-0.183 -0.417,0.283 -0.356,0.606c-4.785,4.175 5.145,6.555 6.738,6.11Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    d: "M47.474,90.102c0.287,-0.134 0.247,-1.13 -0.066,-1.181c-6.053,-0.978 -10.082,-5.757 -9.929,-5.34c-5.455,6.617 7.971,7.465 9.995,6.521Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    d: "M46.167,96.223c0.259,-0.182 0.044,-1.142 -0.272,-1.152c-5.024,-0.151 -11.287,-3.963 -11.063,-3.578c-4.202,7.475 9.51,6.02 11.335,4.73Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    d: "M116.822,89.485c0.246,-0.37 -4.8,3.319 -10.913,2.836c-0.317,-0.024 -0.591,0.934 -0.344,1.132c1.743,1.397 14.987,3.753 11.257,-3.968Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    d: "M118.294,97.54c0.307,-0.321 -6.68,1.9 -11.6,0.856c-0.31,-0.066 -0.746,0.816 -0.538,1.055c1.473,1.681 14.449,6.347 12.138,-1.911Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    d: "M58.984,140.279c0.288,-0.073 0.381,-0.908 0.114,-1.037c-3.076,-1.677 -5.791,-3.945 -7.988,-6.673c-0.027,-0.237 -0.171,-0.4 -0.328,-0.352c-0.244,-0.219 -0.529,0.332 -0.449,0.719c-6.064,4.933 6.624,7.86 8.651,7.343Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    d: "M54.469,147.155c0.226,-0.063 0.3,-0.764 0.095,-0.871c-2.428,-1.411 -4.544,-3.3 -6.222,-5.552c-0.02,-0.2 -0.132,-0.335 -0.255,-0.293c-0.19,-0.183 -0.417,0.283 -0.356,0.606c-4.785,4.175 5.145,6.555 6.738,6.11Z",
    style: {
      fill: "#8292a8",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    d: "M70.141,103.352c0,0 0,0.001 0,0.001c0,0.213 -0.175,0.388 -0.388,0.388c-0.213,-0 -0.388,-0.175 -0.388,-0.388c0,-0.213 0.175,-0.388 0.388,-0.388c0,-0 0.001,-0 0.001,-0c0.212,0.001 0.386,0.175 0.387,0.387Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    cx: 70.335,
    cy: 106.261,
    r: 0.582,
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    d: "M73.63,104.903c0,0.214 -0.347,0.387 -0.775,0.387c-0.428,-0 -0.776,-0.173 -0.776,-0.387c0,-0.214 0.347,-0.387 0.776,-0.387c0.429,-0 0.775,0.173 0.775,0.387Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    d: "M78.283,105.679c0,0.214 -0.26,0.387 -0.582,0.387c-0.322,0 -0.582,-0.173 -0.582,-0.387c0,-0.214 0.26,-0.388 0.582,-0.388c0.322,0 0.582,0.174 0.582,0.388Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    cx: 80.802,
    cy: 106.454,
    rx: 0.727,
    ry: 0.388,
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    d: "M80.608,109.167c0,0.214 -0.26,0.388 -0.582,0.388c-0.322,0 -0.581,-0.174 -0.581,-0.388c0,-0.214 0.26,-0.387 0.581,-0.387c0.321,0 0.582,0.174 0.582,0.387Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    d: "M79.057,107.811c0,0.321 -0.347,0.582 -0.775,0.582c-0.428,-0 -0.775,-0.26 -0.775,-0.582c0,-0.322 0.347,-0.582 0.775,-0.582c0.428,-0 0.775,0.26 0.775,0.582Z",
    style: {
      fill: "#b2b2b2",
      fillRule: "nonzero"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatAndDog);
export default __webpack_public_path__ + "static/media/cat-and-dog.bdd5f4ea.svg";
export { ForwardRef as ReactComponent };